import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../contexts/DialogContext';
import { useAddToast } from '../../contexts/ToastContext';
import { post } from '../../redux/api';
import { LabeledCheckbox } from '../generic';
import Button from '../generic/Button';
import Card from '../generic/Card/Card';

const IssueCountBackfillCard: VoidFunctionComponent = () => {
  const { onConfirm } = useDialogContext();
  const addToast = useAddToast();
  const [shouldOverwriteExisting, setShouldOverwrite] = useState(false);

  const onButtonClick = () => {
    onConfirm({
      title: 'Backfill Issue Count Snapshots',
      body: 'Are you sure you want to backfill issue count snapshots for this org?',
      onConfirm: async () => {
        try {
          await post('/api/issue_counts/backfill', { shouldOverwriteExisting });
          addToast({ type: 'success', content: 'Issue count snapshot backfill queued.' });
        } catch (_err) {
          addToast({
            type: 'error',
            content: 'Failed to queue issue count snapshot backfill.',
          });
        }
      },
    });
  };

  return (
    <Card isFullWidth>
      <Card.Header>
        Issue Count Snapshot
      </Card.Header>
      <Card.Content>
        <div>
          This will trigger a background job that backfills Issue Count Snapshots for this organization.
        </div>
        <LabeledCheckbox
          onChange={() => setShouldOverwrite(!shouldOverwriteExisting)}
          label="Override existing data?"
          isChecked={shouldOverwriteExisting}
        />
        <Button onClick={onButtonClick}>
          Backfill
        </Button>
      </Card.Content>
    </Card>
  );
};

export default IssueCountBackfillCard;
